import {Box, Button, ButtonGroup, Flex, HStack, useToken} from '@chakra-ui/react';
import React, {useEffect, useState} from 'react';
import {atom, useRecoilState} from 'recoil';
import {CloseIcon} from '@chakra-ui/icons';
// import { isMobileState } from '../../../providers/recoil/global';
import MenuKit from '../../../components/kits/Menu';
import {BsFillGridFill} from 'react-icons/bs';
import {FaList} from 'react-icons/fa';
import {motion} from 'framer-motion';
import Container from "../../../components/Container";
import axios from "axios";
import {htmlDecode} from "../../../utils/htmlDecode";
import {useParams, useSearchParams} from "react-router-dom";

const companyViewState = atom({
    key: 'companies-nav__view',
    default: 'grid',
});
const initialState = {
    technology: null,
    private_healthcare: null,
    investment_status: false,
    alumni: false,
    firstInvestment: null,
    featured: null,
};
const companyFilterState = atom({
    key: 'companies-nav__filter',
    default: initialState,
});

const PortfolioNav = () => {
    const [view, setView] = useRecoilState(companyViewState);
    const [filter, setFilter] = useRecoilState(companyFilterState);
    const [openFilter, setOpenFilter] = useState(false);
    // const isMobileView = useRecoilValue(isMobileState);
    const brand700 = useToken('color', ['brand.700']);
    const [searchParams, setSearchParams] = useSearchParams();
    const activeSector = searchParams.get('sector')

    const [techOptions, setTechOptions] = useState([{title: 'All', value: 'All'}])
    const [technologyDropdown, setTechnologyDropdown] = useState(undefined)
    const [healthDropdown, setHealthDropdown] = useState(undefined)
    const [healthOptions, setHealthOptions] = useState([{title: 'All', value: 'All'}])

    useEffect(() => {
        if (techOptions?.length > 0 && activeSector) {
            // eslint-disable-next-line no-unused-expressions
            techOptions?.map((opt) => {
                if (htmlDecode(opt.title.toLowerCase()) === htmlDecode(activeSector.toLowerCase())) {
                    setFilter(() => ({
                        ...initialState,
                        technology: opt.value,
                    }))
                }
            })
        }
        if (healthOptions?.length > 0 && activeSector) {
            // eslint-disable-next-line no-unused-expressions
            healthOptions?.map((opt) => {
                if (htmlDecode(opt.title.toLowerCase()) === htmlDecode(activeSector.toLowerCase())) {
                    setFilter(() => ({
                        ...initialState,
                        private_healthcare: opt.value,
                    }))
                }
                return opt
            })
        }

    }, [activeSector, techOptions, healthOptions, setFilter])

    useEffect(() => {
        const fetchData = async () => {
            const techData = await axios.get(`/wp-json/wp/v2/sector?_fields[]=slug&_fields[]=name&_fields[]=count&per_page=100&parent=7`).then(resp => {
                return resp.data;
            });
            const healthData = await axios.get(`/wp-json/wp/v2/sector?_fields[]=slug&_fields[]=name&_fields[]=count&per_page=100&parent=6`).then(resp => {
                return resp.data;
            });
            if (techData?.length > 0) {
                setTechOptions([
                    ...techOptions,
                    ...techData?.map((opt) => {
                        return {
                            title: htmlDecode(opt.name), value: htmlDecode(opt.name)
                        }
                    })
                ])
            }
            if (healthData?.length > 0) {
                setHealthOptions([
                    ...healthOptions,
                    ...healthData?.map((opt) => {
                        return {
                            title: htmlDecode(opt.name), value: htmlDecode(opt.name)
                        }
                    })
                ])
            }
        }
        fetchData()
    }, [])


    useEffect(() => {
        if (techOptions?.length > 0) {
            const techOptionsData = techOptions?.map((item) => ({
                ...item,
                onClick: () => {
                    setFilter(() => ({
                        ...initialState,
                        technology: item.value,
                    }))
                    setSearchParams({
                        sector: htmlDecode(item.value)
                    })
                }
            }))
            setTechnologyDropdown(
                techOptionsData
            )
        }
    }, [setFilter, setSearchParams, techOptions])

    useEffect(() => {
        if (healthOptions?.length > 0) {
            const healthOptionsData = healthOptions?.map((item) => ({
                ...item,
                onClick: () => {
                    setFilter(() => ({
                        ...initialState,
                        private_healthcare: item.value,
                    }))
                    setSearchParams({
                        sector: htmlDecode(item.value)
                    })
                }
            }))
            setHealthDropdown(
                healthOptionsData
            )
        }
    }, [healthOptions, setFilter, setSearchParams])


    const firstInvestmentDropdown = [
        {title: 'Seed', value: 'Seed'},
        {title: 'Series A', value: 'Series A'},
        {title: 'Series B', value: 'Series B'},
        {title: 'Series C', value: 'Series C'},
    ].map((item) => ({
        ...item,
        onClick: () =>
            setFilter(() => ({
                ...initialState,
                firstInvestment: item.value,
            })),
    }));
    return (
        <>
            <Box borderX={'1px'} borderColor={'brandAlpha.200'}>
                <Box position={'relative'}>
                    <Container>
                        <motion.div
                            initial={{y: 50, opacity: 0}}
                            animate={{y: 0, opacity: 1}}
                            transition={{
                                delay: 0.3,
                                default: {duration: 0.5},
                            }}
                        >
                            <Box pb={[view === 'grid' ? '30px' : '5px', '33px']} as="section">
                                <Box as="nav">
                                    <Flex px={['2.5', '5']} justify="space-between" wrap={'wrap'}>
                                        <ButtonGroup flexWrap={'wrap'} spacing="1">
                                            <Button
                                                onClick={() => {
                                                    setOpenFilter(true);
                                                    setFilter(initialState);
                                                }}
                                                isActive={
                                                    !Object.values(filter)
                                                        .map((item) => !!item)
                                                        .includes(true)
                                                }
                                                display={['flex', 'none']}
                                            >
                                                <Box as="span" display={{base: 'inline-block', md: 'none'}}>
                                                    Filter:{' '}
                                                </Box>{' '}
                                                All
                                            </Button>
                                            <Button
                                                onClick={() => {
                                                    setFilter(initialState);
                                                }}
                                                display={['none', 'flex']}
                                                isActive={
                                                    !Object.values(filter)
                                                        .map((item) => !!item)
                                                        .includes(true)
                                                }
                                            >
                                                <Box as="span" display={{base: 'inline-block', md: 'none'}}>
                                                    Filter:{' '}
                                                </Box>{' '}
                                                All
                                            </Button>
                                            <Box flexWrap={'wrap'} display={['none', 'flex']}>
                                                <MenuKit
                                                    gutter={20}
                                                    buttonProps={{
                                                        children: filter.technology || 'Technology',
                                                        isActive: filter.technology !== null,
                                                    }}
                                                    activeItem={filter.technology}
                                                    options={technologyDropdown}
                                                />
                                                <MenuKit
                                                    gutter={20}
                                                    buttonProps={{
                                                        children: filter.private_healthcare || 'Private Healthcare',
                                                        isActive: filter.private_healthcare !== null,
                                                    }}
                                                    activeItem={filter.private_healthcare}
                                                    options={healthDropdown}
                                                />
                                            </Box>
                                            <ButtonGroup display={['none', 'flex']} flexWrap={'wrap'} spacing="1">
                                                <Button
                                                    onClick={() =>
                                                        setFilter((s) => ({
                                                            ...initialState,
                                                            investment_status: !s['investment_status'],
                                                        }))
                                                    }
                                                    isActive={filter.investment_status}
                                                >
                                                    Active
                                                </Button>
                                                <Button
                                                    onClick={() =>
                                                        setFilter((s) => ({
                                                            ...initialState,
                                                            alumni: !s['alumni'],
                                                        }))
                                                    }
                                                    isActive={filter.alumni}
                                                >
                                                    Alumni
                                                </Button>
                                                <Button
                                                    onClick={() =>
                                                        setFilter((s) => ({
                                                            ...initialState,
                                                            featured: !s['featured'],
                                                        }))
                                                    }
                                                    isActive={filter.featured}
                                                >
                                                    Featured
                                                </Button>
                                                <MenuKit
                                                    gutter={20}
                                                    buttonProps={{
                                                        children: filter.firstInvestment || 'First Investment',
                                                        isActive: filter.firstInvestment !== null,
                                                    }}
                                                    activeItem={filter.firstInvestment}
                                                    options={firstInvestmentDropdown}
                                                />
                                            </ButtonGroup>
                                        </ButtonGroup>

                                        <HStack spacing="2">
                                            <>
                                                {!openFilter && (
                                                    <ButtonGroup>
                                                        <Button
                                                            iconSpacing={0}
                                                            size={'xs'}
                                                            leftIcon={<BsFillGridFill/>}
                                                            variant={'brand'}
                                                            borderRadius={'full'}
                                                            colorScheme={'brand'}
                                                            isActive={view === 'grid'}
                                                            onClick={() => setView('grid')}
                                                        />
                                                        <Button
                                                            iconSpacing={0}
                                                            size={'xs'}
                                                            leftIcon={<FaList/>}
                                                            variant={'brand'}
                                                            borderRadius={'full'}
                                                            colorScheme={'brand'}
                                                            onClick={() => setView('list')}
                                                            isActive={view === 'list'}
                                                        />
                                                    </ButtonGroup>
                                                )}
                                                {openFilter && (
                                                    <Button
                                                        size={'xs'}
                                                        variant={'solid'}
                                                        bgColor={brand700}
                                                        color={'white'}
                                                        onClick={() => setOpenFilter(false)}
                                                        iconSpacing={0}
                                                        borderRadius={'full'}
                                                    >
                                                        <CloseIcon/>
                                                    </Button>
                                                )}
                                            </>
                                        </HStack>
                                    </Flex>
                                    {openFilter && (
                                        <Flex px={'2.5'} wrap={'wrap'} gap={'15px'} mt={'15px'}>
                                            <MenuKit
                                                gutter={20}
                                                buttonProps={{
                                                    children: filter.technology || 'Technology',
                                                    size: 'sm',
                                                    py: '18px',
                                                    textColor: 'black',
                                                    fontWeight: 'semibold',
                                                    fontSize: 'xs',
                                                    variant: 'brand',
                                                    borderRadius: 'full',
                                                    colorScheme: 'brand',
                                                    borderColor: 'rgba(11, 46, 251, 0.5)',
                                                }}
                                                options={technologyDropdown}
                                                activeItem={filter.technology}
                                            />
                                            <MenuKit
                                                gutter={20}
                                                buttonProps={{
                                                    children: filter.private_healthcare || 'Private Healthcare',
                                                    size: 'sm',
                                                    py: '18px',
                                                    textColor: 'black',
                                                    fontWeight: 'semibold',
                                                    fontSize: 'xs',
                                                    variant: 'brand',
                                                    borderRadius: 'full',
                                                    colorScheme: 'brand',
                                                    borderColor: 'rgba(11, 46, 251, 0.5)',
                                                }}
                                                options={healthDropdown}
                                                activeItem={filter.private_healthcare}
                                            />

                                            <ButtonGroup spacing="3">
                                                <Button
                                                    size={'sm'}
                                                    py={'18px'}
                                                    textColor={'black'}
                                                    fontWeight={'semibold'}
                                                    fontSize={'xs'}
                                                    variant={'brand'}
                                                    borderRadius={'full'}
                                                    colorScheme={'brand'}
                                                    borderColor={'rgba(11, 46, 251, 0.5)'}
                                                    onClick={() =>
                                                        setFilter((s) => ({
                                                            ...initialState,
                                                            investment_status: !s['investment_status'],
                                                        }))
                                                    }
                                                    isActive={filter.investment_status}
                                                >
                                                    Active
                                                </Button>{' '}
                                                <Button
                                                    size={'sm'}
                                                    py={'18px'}
                                                    textColor={'black'}
                                                    fontWeight={'semibold'}
                                                    fontSize={'xs'}
                                                    variant={'brand'}
                                                    borderRadius={'full'}
                                                    colorScheme={'brand'}
                                                    borderColor={'rgba(11, 46, 251, 0.5)'}
                                                    onClick={() =>
                                                        setFilter((s) => ({
                                                            ...initialState,
                                                            alumni: !s['alumni'],
                                                        }))
                                                    }
                                                    isActive={filter.alumni}
                                                >
                                                    Alumni
                                                </Button>{' '}
                                                <MenuKit
                                                    gutter={20}
                                                    buttonProps={{
                                                        children: filter.firstInvestment || 'First Investment',
                                                        size: 'sm',
                                                        py: '18px',
                                                        textColor: 'black',
                                                        fontWeight: 'semibold',
                                                        fontSize: 'xs',
                                                        variant: 'brand',
                                                        borderRadius: 'full',
                                                        colorScheme: 'brand',
                                                        borderColor: 'rgba(11, 46, 251, 0.5)',
                                                        isActive: filter.firstInvestment !== null,
                                                    }}
                                                    options={firstInvestmentDropdown}
                                                    activeItem={filter.firstInvestment}
                                                />
                                            </ButtonGroup>
                                        </Flex>
                                    )}
                                </Box>
                            </Box>
                        </motion.div>
                    </Container>
                </Box>
            </Box>
        </>
    );
};

export default PortfolioNav;
export {companyViewState, companyFilterState};
